import React, { useState, useMemo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FIELDS, MODE, TOAST_MESSAGES } from "../../../constants/SiteConstants";
import "../../../styles/Form.css";
import { useJsApiLoader } from "@react-google-maps/api";
import AWS from "../../../utils/awsConfig.js";
import axios from "axios";
import VendorForm from "./VendorForm.js";

const API_URL = process.env.REACT_APP_API_URL;

const fields = [
  {
    label: FIELDS.NAME,
    name: "name",
    placeholder: "Enter vendor name",
    required: true,
  },
  {
    label:"Enable or Disable ",
    name: "isActive",
    type: "checkbox",
  },
  {
    label:"OwnerName" ,
    name: "ownerName",
    placeholder: "Enter vendor name",
    required: true,
  },
  {
    label:"Head Office Location" ,
    name: "location",
    placeholder: "Enter Head Office Location",
    required: true,
  },
  {
    name: "state",
    placeholder: "Enter State name",
    required: true,
    isMultifield:true,
  },
  {
    name: "city",
    placeholder: "Enter City name",
    required: true,
    isMultifield:true,

  },
 
  {
    label: FIELDS.EMAIL,
    name: "email",
    placeholder: "Enter email address",
    required: true,
  },
  {
    label: FIELDS.RANKING,
    name: "ranking",
    placeholder: "Enter ranking ",
    required: true,
  },
  {
    label: FIELDS.PHONE,
    name: "phone",
    placeholder: "Enter phone number",
    required: true,
  },
  {
    label: FIELDS.SLUG,
    name: "slug",
    placeholder: "Enter Slug",
    required: false, // Make it optional so it can be auto-generated
    type: "text",
  },
  {
    label:"Sponsored",
    name: "sponsored",
    type: "checkbox",
  },
  {
    label:"Approved By Government",
    name: "approvedByGovernment",
    type: "checkbox",
  },
  {
    label:"Approved By SolarStation",
    name: "approvedBySolarStation",
    type: "checkbox",
  },
  {
    label:"Verified",
    name: "verified",
    type: "checkbox",
  },
  {
    label: FIELDS.DESCRIPTION,
    name: "description",
    placeholder: "Enter vendor description",
    required: true,
    type: "rich-text",
  },
  {
    label: FIELDS.IMAGE,
    name: "image",
    placeholder: "Enter image",
    type: "file",
  },
  {
    label: FIELDS.TAGS,
    name: "tags",
    placeholder: "Select tags",
    required: false,
    isTagsMultifield: true,
  },
 
];

const AddVendor = () => {
  const navigate = useNavigate();
  const [imageFiles, setImageFiles] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);

  const loaderOptions = useMemo(() => ({
      id: "google-map-script",
      googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
      libraries: ["places"],
    }), []);

  const { isLoaded } = useJsApiLoader(loaderOptions);

const handleImageUpload = async (file) => {
  if (!file) {
    toast.error("No file selected!");
    return null;
  }

  const formData = new FormData();
  formData.append("image", file);

  try {
    const response = await fetch(`${API_URL}/image/upload`, {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || "Upload failed");
    }

    return data.imageUrl;
  } catch (error) {
    console.error("Upload Error:", error);
    toast.error("Error uploading image: " + error.message);
    return null;
  }
};


const handleSubmit = async (formData) => {
  try {
    const loggedInUser = JSON.parse(localStorage.getItem("user"));
    const userId = loggedInUser?._id;

    if (!userId) {
      toast.error("Admin ID not found in localStorage.");
      return;
    }

    const uploadedImageUrl =
      imageFiles.length > 0 ? await handleImageUpload(imageFiles[0]) : null;

    formData.image = uploadedImageUrl;
    formData.password = "123456";
    formData.slug =
      formData.slug?.trim() !== ""
        ? formData.slug
        : formData.name.replace(/\s+/g, "-").toLowerCase();

    formData.branches = formData.branches?.map((branch) => ({
      phone: branch.phone,
      branchAddress: branch.branchAddress,
      city: branch.city,
      state: branch.state,
      location: {
        address: branch.location?.address,
        lat: branch.location?.lat,
        lng: branch.location?.lng,
      },
    })) || [];

    const payload = {
      ...formData,
      userId,
    };

    await axios.post(`${API_URL}/vendor/add`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    toast.success(TOAST_MESSAGES.DATA_SAVED);
    navigate("/vendors");
  } catch (error) {
    console.error("Error adding vendor:", error);
    toast.error(error.response?.data?.error || TOAST_MESSAGES.ERROR_ADD);
  }
};



  
  const handleImageChange = (e) => {
    const files = e.target.files;
    setImageFiles(files);
    setImagePreviews(Array.from(files).map((file) => URL.createObjectURL(file)));
  };

  // Clean up image URLs on component unmount
  useEffect(() => {
    return () => {
      imagePreviews.forEach((preview) => URL.revokeObjectURL(preview));
    };
  }, [imagePreviews]);

  return (
    <div className="form-wrapper">
      <div className="form-header">
        <h2 className="form-title">Add Vendor</h2>
        <button className="form-close-btn" onClick={() => navigate("/vendors")}>
          &times;
        </button>
      </div>
      {isLoaded ? (
        <VendorForm
          mode={MODE.ADD}
          onSubmit={handleSubmit}
          fields={fields}
          imagePreviews={imagePreviews}
          handleImageChange={handleImageChange}
          isGoogleMapLoaded={isLoaded}
        />
      ) : (
        <p>Loading Google Maps...</p>
      )}
    </div>
  );
};

export default AddVendor;
